/*
 * PDP Short Description — reveals the More/Less control only when the text is
 * actually clamped. A control that does nothing is worse than no control.
 */
(function () {
  function init(wrap) {
    if (wrap.dataset.shortDescriptionReady === 'true') return;

    var text = wrap.querySelector('.product-short-description__text');
    var toggle = wrap.querySelector('.product-short-description__toggle');
    if (!text || !toggle) return;

    wrap.dataset.shortDescriptionReady = 'true';

    // Overflowing only if the unclamped height exceeds the clamped height.
    if (text.scrollHeight <= text.clientHeight + 1) {
      toggle.remove();
      return;
    }

    toggle.hidden = false;
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      wrap.classList.toggle('is-expanded', !expanded);
    });
  }

  function initAll() {
    document
      .querySelectorAll('.product-short-description')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Webfont swap can change the measured height after first paint.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initAll);
  }

  // Variant changes and theme-editor block re-renders replace the markup.
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
